import {lighten, makeStyles} from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import clsx from "clsx";
import {Button, Grid} from "@material-ui/core";
import ExcelFile from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/components/ExcelFile";
import ExcelSheet from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/elements/ExcelSheet";
import ExcelColumn from "@ibrahimrahmani/react-export-excel/dist/ExcelPlugin/elements/ExcelColumn";
import Typography from "@material-ui/core/Typography";
import React from "react";

export const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.primary.main,
                backgroundColor: lighten(theme.palette.primary.light, 0.85),
                border: 0,
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.primary.dark,
            },
    title: {
        flex: '1 1 50%',
    },
}));

export const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    const {numSelected, selectedItem} = props;

    let reworked = [];

    selectedItem.forEach(contact => {
        // let warningDekon = false;
        reworked.push({
             Name: contact['Name'],
             Compagny: contact['Compagny'],
             Tel: String(contact['Tel']),
        })

    })



    return (
        <>
            <Toolbar className={clsx(classes.root, {[classes.highlight]: numSelected > 0})}>
                {numSelected > 0 ? (
                    <Grid container className={classes.title}>
                        <Grid>
                            <Button style={{marginRight: 20}}> {"Séléctionnés : " + numSelected} </Button>
                        </Grid>
                        <Grid>
                            <ExcelFile element={<Button style={{backgroundColor: "green", color: "white"}} >Exporter en
                                excel</Button>}>
                                <ExcelSheet data={reworked} name="Contact">
                                     <ExcelColumn label="Name" value="Name"/>
                                    <ExcelColumn label=" Compagny" value="Compagny"/>
                                    <ExcelColumn label="Tel" value="Tel"/>
                                </ExcelSheet>
                            </ExcelFile>
                        </Grid>
                    </Grid>
                ) : (
                    <Typography className={classes.title} color='primary'
                                variant="h6" id="tableTitle" component="div">
                        LIST DES CONTACTS 
                    </Typography>
                )}
            </Toolbar>
        </>
    );
};